const imageBaseUrl = process.env.REACT_APP_IMAGE_URL

const ChooseUsImg1 = imageBaseUrl + "ChooseUsImg1.svg";
const ChooseUsImg2 = imageBaseUrl + "ChooseUsImg2.svg";
const ChooseUsImg3 = imageBaseUrl + "ChooseUsImg3.svg";
const ChooseUsImg4 = imageBaseUrl + "ChooseUsImg4.svg";
const ChooseUsImg5 = imageBaseUrl + "ChooseUsImg5.svg";

const studentWorkData = [
  {
    title: "Students from Indian HEIs can study at one of our <b>partner institutions</b> within India or abroad for a portion of their program or as part of an internship.",
   
    Image: ChooseUsImg3,
  },
  {
    title: `We ensure <b>smooth credit transfers</b> and compliance with <b>AICTE guidelines</b>.`,
    Image: ChooseUsImg2,
  },
  {
    title: `The programme includes both <b>physical and virtual exchange opportunities</b>, making global learning accessible.`,
   Image: ChooseUsImg1,
  },
  {
    title: `Students return to their <b>parent institution</b> to complete their degree requirements.`,
    Image: ChooseUsImg4,
  },
  {
    title: `Typical duration: <b>One or two semesters</b>.`,
    Image: ChooseUsImg5,
  },
];

export default studentWorkData;
